module.exports = __webpack_public_path__ + "img/demo5-poster.fca12545.jpg";